import { render, staticRenderFns } from "./offer-form-modal.vue?vue&type=template&id=012419f9&scoped=true&"
import script from "./offer-form-modal.vue?vue&type=script&lang=js&"
export * from "./offer-form-modal.vue?vue&type=script&lang=js&"
import style0 from "./offer-form-modal.vue?vue&type=style&index=0&id=012419f9&lang=scss&scoped=true&"
import style1 from "./offer-form-modal.vue?vue&type=style&index=1&id=012419f9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "012419f9",
  null
  
)

export default component.exports
import {QDialog,QCard,QCardSection,QIcon,QSpinnerIos,ClosePopup} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QDialog,QCard,QCardSection,QIcon,QSpinnerIos})
component.options.directives = Object.assign(Object.create(component.options.directives || null), component.options.directives || {}, {ClosePopup})
